import React, { ReactElement } from 'react';

type ArrowIconProps = {
  className?: string;
};

import './ArrowIcon.scss';

const ArrowIcon = ({ className = '' }: ArrowIconProps): ReactElement => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"
      fill="white"
    />
  </svg>
);

export default ArrowIcon;
